export default __webpack_public_path__ + "static/media/diamond-clarity-5@2x.fe0ec7d6.png";